import { Component } from '@angular/core';

@Component({
  selector: 'app-blank-success',
  template: '<div>ok</div>',
  styles: [
    `
    div {
      display: none;
    }
    `
  ]
})
export class BlankSuccessComponent {

}
